import { render, staticRenderFns } from "./details-evaluate-content.vue?vue&type=template&id=24703767&scoped=true"
import script from "./details-evaluate-content.vue?vue&type=script&lang=js"
export * from "./details-evaluate-content.vue?vue&type=script&lang=js"
import style0 from "./details-evaluate-content.vue?vue&type=style&index=0&id=24703767&prod&lang=scss"
import style1 from "./details-evaluate-content.vue?vue&type=style&index=1&id=24703767&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24703767",
  null
  
)

export default component.exports